var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Card",
    [
      _c(
        "Row",
        { attrs: { gutter: 16 } },
        [
          _c("Col", { attrs: { span: "24" } }, [
            _c("div", { staticClass: "global-tool-bar" }, [
              _c("div", { staticClass: "left-bar" }, [
                _c("span", { staticClass: "title" }, [_vm._v("投诉建议管理")]),
              ]),
              _c("div", { staticClass: "right-bar" }),
            ]),
          ]),
        ],
        1
      ),
      _vm.suggestionFormShow
        ? _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Form",
                { attrs: { "label-width": 80, "label-position": "right" } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "8" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "详细内容" } },
                        [
                          _c("Input", {
                            attrs: { readonly: "" },
                            model: {
                              value: _vm.suggestionForm.suggestionDetail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.suggestionForm,
                                  "suggestionDetail",
                                  $$v
                                )
                              },
                              expression: "suggestionForm.suggestionDetail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "相关图片" } },
                        [
                          _vm.suggestionForm.suggestionImages !== ""
                            ? _c(
                                "Button",
                                {
                                  attrs: { type: "info" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onShowImage(
                                        _vm.suggestionForm.suggestionImages
                                      )
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "20" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "回复内容" } },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.suggestionForm.suggestionReplayDetail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.suggestionForm,
                                  "suggestionReplayDetail",
                                  $$v
                                )
                              },
                              expression:
                                "suggestionForm.suggestionReplayDetail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "form-button",
                          attrs: { type: "success" },
                          on: { click: _vm.onSave },
                        },
                        [_vm._v("保存")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "form-button",
                          attrs: { type: "text" },
                          on: { click: _vm.onCancel },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "Row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "Col",
            { attrs: { span: "24" } },
            [
              _c("stand-pagination-table", {
                attrs: {
                  columns: _vm.mainTable.columns,
                  data: _vm.mainTable.data,
                  loading: _vm.mainTable.loading,
                  "table-search": _vm.mainTable.tableSearch,
                  "table-load-event": _vm.getSuggestionTableRecords,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }